module.exports = __webpack_public_path__ + "static/media/KR.28b05004.svg";